import { Injectable } from '@angular/core';
import { Activity } from '@wilson/interfaces';

type PriorityClasses = Record<number, string>;

@Injectable({
  providedIn: 'root',
})
export class PriorityHelperService {
  getHighestPriority(activities?: Activity[]): number | null {
    if (activities && activities.length) {
      let highestPriority: number | null = null;

      for (const activity of activities) {
        if (
          activity.priority !== null &&
          (highestPriority === null || activity.priority! < highestPriority)
        ) {
          highestPriority = activity.priority!;
        }
      }
      return highestPriority;
    }
    return null;
  }

  priorityComparator(a: number, b: number) {
    if (a === null && b === null) {
      return 0;
    } else if (a === null) {
      return -1;
    } else if (b === null) {
      return 1;
    } else {
      return b - a;
    }
  }

  public setColor(priority: number, isTextBold: boolean): string {
    const priorityClasses: PriorityClasses = {
      1: 'priority-one',
      2: 'priority-two',
      3: 'priority-three',
      4: 'priority-four',
      5: 'priority-five',
    };

    const className = priorityClasses[priority];

    if (className) {
      return isTextBold ? `${className} badge` : className;
    }

    return '';
  }

  getPriorities(): number[] {
    return [1, 2, 3, 4, 5];
  }
}
